import { useIntl } from 'react-intl'

import { trackClientEvent } from 'analytics/analytics'
import BodyText from 'LuxKit/Typography/BodyText'
import Modal from 'LuxKit/Modal/Modal'

function RefreshSearchModal() {
  const intl = useIntl()

  return (
    <Modal
      title={intl.formatMessage({
        id: 'rbYvIvLreEGlA63e23oj',
        defaultMessage: 'Your search session has expired',
        description: 'Title for the expired search session modal in the search interface',
      })}
      primaryActionText={intl.formatMessage({
        id: 'M8LKNactvVlY8PjnoDls',
        defaultMessage: 'Refresh',
        description: 'Refresh button label to reload search results in the search interface',
      })}
      onPrimaryActionClick={() => {
        trackClientEvent({
          subject: 'expired',
          action: 'refresh',
          category: 'search',
          type: 'interaction',
        })
        window.location.reload()
      }}
    >
      <BodyText variant="large">
        {intl.formatMessage({
          id: 'LDEV7KxnCrcPprGK3AwW',
          defaultMessage: 'Refresh your search to see available offers.',
          description: 'Body text explaining the search needs refreshing to see offers',
        })}
      </BodyText>
    </Modal>
  )
}

export default RefreshSearchModal
